const ViewMode = Object.freeze({
  DIAGRAM: 'DIAGRAM',
  INSIGHTS: 'INSIGHTS',
  TABLE: 'TABLE',
  BULK_EDIT: 'BULK_EDIT',
  CUSTOM_CHART: 'CUSTOM_CHART',
  PLAN: 'PLAN',
  REPORTS: 'REPORTS',
  DEBUG: 'DEBUG',
});

export default ViewMode;
